<!--begin::Menu wrapper-->
<div id="kt_app_sidebar_menu_scroll" class="scroll-y my-5 mx-3" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer" data-kt-scroll-wrappers="#kt_app_sidebar_menu" data-kt-scroll-offset="5px" data-kt-scroll-save-state="true">
  <!--begin::Menu-->
  <div class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6" id="#kt_app_sidebar_menu" data-kt-menu="true" data-kt-menu-expand="false">
    <!-- Menu -->
    <ng-container *ngFor="let section_menu of SYSTEM_NAVIGATION_MENU">
      <div class="menu-item">
        <!-- Menu Item -->
        <section *ngIf="section_menu.type === 'item'">
          <ng-container [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ menu: section_menu }"></ng-container>
        </section>

        <!-- Menu Accordion -->
        <section *ngIf="section_menu.type === 'accordion'">
          <ng-container [ngTemplateOutlet]="accordion" [ngTemplateOutletContext]="{ menu: section_menu }"></ng-container>
        </section>

        <!-- Menu Section -->
        <section *ngIf="section_menu.type === 'section'">
          <ng-container [ngTemplateOutlet]="section" [ngTemplateOutletContext]="{ menu: section_menu }"></ng-container>
        </section>
      </div>
    </ng-container>
  </div>
  <!--end::Menu-->
</div>
<!--end::Menu wrapper-->

<!-- Template Menu Item -->
<ng-template #item let-menu="menu">
  <a class="menu-link without-sub" [routerLink]="menu.url" routerLinkActive="active">
    @if (menu.icon?.length) {
    <span class="menu-icon">
      <app-keenicon [name]="menu.icon!" class="fs-2 text-light"></app-keenicon>
    </span>
    }@else {
    <span class="menu-bullet">
      <span class="bullet bullet-dot"></span>
    </span>
    }
    <span class="menu-title">{{ menu.title | translate }}</span>
    <!-- <span class="menu-title" translate="MENU.DASHBOARD"></span> -->
  </a>
</ng-template>

<!-- Template Menu Accordion -->
<ng-template #accordion let-menu="menu">
  <div class="menu-item menu-accordion" data-kt-menu-trigger="click" routerLinkActive="here show">
    <span class="menu-link">
      <span class="menu-icon">
        <app-keenicon [name]="menu.icon!" class="fs-2 text-light"></app-keenicon>
      </span>
      <span class="menu-title" [attr.data-link]="menu.url">{{ menu.title | translate }}
      </span>
      <span class="menu-arrow"></span>
    </span>
    <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
      <section *ngFor="let sub_menu of menu.children!">
        <!-- Menu Section accordion with sub-menu accordion -->
        <div *ngIf="sub_menu.type === 'accordion'" class="menu-item menu-accordion" routerLinkActive="here show" data-kt-menu-trigger="click">
          <span class="menu-link">
            <span class="menu-bullet">
              <span class="bullet bullet-dot"></span>
            </span>
            <span class="menu-title" [attr.data-link]="sub_menu.url">{{ sub_menu.title | translate }}
            </span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
            <div class="menu-item" *ngFor="let children of sub_menu.children">
              <app-side-menu-item [menu]="children"></app-side-menu-item>
            </div>
          </div>
        </div>

        <!-- Menu Section accordion with sub-menu item -->
        <div class="menu-item" *ngIf="sub_menu.type === 'item'">
          <a class="menu-link without-sub" [routerLink]="sub_menu.url" routerLinkActive="active">
            @if (sub_menu.icon?.length) {
            <span class="menu-icon">
              <app-keenicon [name]="sub_menu.icon!" class="fs-2"></app-keenicon>
            </span>
            }@else {
            <span class="menu-bullet">
              <span class="bullet bullet-dot"></span>
            </span>
            }
            <span class="menu-title" [attr.data-link]="sub_menu.url">{{
              sub_menu.title | translate
              }}</span>
          </a>
        </div>
      </section>
    </div>
  </div>
</ng-template>

<!-- Template Menu Section -->
<ng-template #section let-menu="menu">
  <div class="menu-item">
    <div class="menu-content pt-8 pb-2">
      <span class="menu-section text-muted text-uppercase fs-8 ls-1">{{
        menu.title | translate
        }}</span>
    </div>
  </div>
  <section *ngFor="let sub_menu of menu.children">
    <!-- Menu Section accordion -->
    <ng-container *ngIf="sub_menu.type === 'accordion'">
      <div class="menu-item menu-accordion" data-kt-menu-trigger="click" routerLinkActive="here show">
        <span class="menu-link">
          <span class="menu-icon">
            <app-keenicon [name]="sub_menu.icon!" class="fs-2 text-light"></app-keenicon>
          </span>
          @if (sub_menu?.children![0]?.type==='accordion') {
          <span class="menu-title">{{ sub_menu.title | translate }}</span>
          } @else if (sub_menu.children[0]?.type==='item') {
          <span class="menu-title" [attr.data-link]="sub_menu.url">{{
            sub_menu.title | translate
            }}</span>
          }
          <!-- <span class="menu-title" [attr.data-link]="sub_menu.url">{{
            sub_menu.title | translate
          }}</span> -->
          <span class="menu-arrow"></span>
        </span>
        <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
          <section *ngFor="let children of sub_menu.children!">
            <!-- Menu Section accordion with sub-menu accordion -->
            <div *ngIf="children.type === 'accordion'" class="menu-item menu-accordion" routerLinkActive="here show" data-kt-menu-trigger="click">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title" [attr.data-link]="children.url">{{ children.title | translate }}
                </span>
                <span class="menu-arrow"></span>
              </span>
              <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
                <div class="menu-item" *ngFor="let sub_children of children.children">
                  <a class="menu-link without-sub" [routerLink]="sub_children.url" routerLinkActive="active">
                    @if (sub_children.icon?.length) {
                    <span class="menu-icon">
                      <app-keenicon [name]="sub_children.icon!" class="fs-2"></app-keenicon>
                    </span>
                    }@else {
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    }
                    <span class="menu-title" [attr.data-link]="sub_children.url">{{ sub_children.title | translate }}</span>
                    <!-- <span class="menu-title" translate="MENU.DASHBOARD"></span> -->
                  </a>
                </div>
              </div>
            </div>

            <!-- Menu Section accordion with sub-menu item -->
            <div class="menu-item" *ngIf="children.type === 'item'">
              <a class="menu-link without-sub" [routerLink]="children.url" routerLinkActive="active">
                @if (children.icon?.length) {
                <span class="menu-icon">
                  <app-keenicon [name]="children.icon!" class="fs-2"></app-keenicon>
                </span>
                }@else {
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                }
                <span class="menu-title" [attr.data-link]="children.url">{{
                  children.title | translate
                  }}</span>
                <!-- <span class="menu-title" translate="MENU.DASHBOARD"></span> -->
              </a>
            </div>
          </section>
        </div>
      </div>
      <!-- <app-side-menu-accordion [menu]="sub_menu"></app-side-menu-accordion> -->
    </ng-container>
    <!-- Menu Section item -->
    <ng-container *ngIf="sub_menu.type === 'item'">
      <div class="menu-item">
        <a class="menu-link without-sub" [routerLink]="sub_menu.url" routerLinkActive="active">
          @if (sub_menu.icon?.length) {
          <span class="menu-icon">
            <app-keenicon [name]="sub_menu.icon!" class="fs-2"></app-keenicon>
          </span>
          }@else {
          <span class="menu-bullet">
            <span class="bullet bullet-dot"></span>
          </span>
          }
          <span class="menu-title" [attr.data-link]="sub_menu.url">{{
            sub_menu.title | translate
            }}</span>
          <!-- <span class="menu-title" translate="MENU.DASHBOARD"></span> -->
        </a>
      </div>
    </ng-container>
  </section>
</ng-template>